export default __webpack_public_path__ + "static/media/deployment-history.2ee5f7c5.png";